<template>
    <div class="content-grid content-grid--subpage content-grid--subpage-table">
        <Breadcrumbs :title="t(`routes.admin.children.organizations.name`)" />
        <div class="content-grid__header">
            <h1 class="back-link-title">{{ t(`routes.admin.children.organizations.name`) }}</h1>
            <div class="content-grid__filters">
                <SearchInput v-model="searchValue" />
            </div>
        </div>
        <Card :title="t('global.quickLinks')" class="card--row-content">
          <BtnLink
            :name="t('routes.admin.children.organizations.merge.name')"
            :path="{ name: 'admin.children.organizations.merge' }"
          />
        </Card>
        <Card>
            <DataTable
                    :headers="organizationHeader"
                    :items="organizations"
                    :is-loading="organizationsAreLoading"
                    :search-value="searchValue"
            />
        </Card>
    </div>
</template>

<script lang="ts" setup>
import Card from "@/components/layout/Card.vue";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import SearchInput from "@/components/layout/SearchInput.vue";
import { useI18n } from "vue3-i18n";
import {ref, onMounted, computed} from "vue";
import { useOrganizationService } from "@/inversify.config";
import DataTable from "@/components/layout/DataTable.vue";
import {IOrganization} from "@/types/entities/organization";
import BtnLink from "@/components/layout/BtnLink.vue";

const { t } = useI18n();

const organizationService = useOrganizationService();

const allOrganizations = ref();
const searchValue = ref("");
const organizationsAreLoading = ref(false);

const organizationHeader = [
  {
    text: t("organization.name"),
    value: "name",
    sortable: true,
    width: 325,
  },
  {
    text: t("organization.status"),
    value: "status",
    sortable: true,
    width: 150,
  },
  {
    text: t("organization.type"),
    value: "type",
    sortable: true,
    width: 125,
  },
  {
    text: t("organization.memberNumber"),
    value: "memberNumber",
    sortable: true,
    width: 150,
  },
  {
      text: t("global.table.actions"),
      value: "actions",
      width: 75
  },
];

const organizations = computed(() => {
    if (allOrganizations.value == null) {
        return []
    }
    return allOrganizations.value.map((x: IOrganization) => {
        return {
            id: x.id,
            crmId: x.crmId,
            name: x.name,
            type: t(`organization.types.${x.type.makeFirstLetterLowercase()}`),
            memberNumber: x.memberNumber,
            status: t(`organization.statuses.${x.subscriptionStatus.makeFirstLetterLowercase()}`),
            actions: {
              view: {name: "admin.children.organizations.view", params: {organizationId: x.id}}
            }
        }
    }) as IOrganization[];
})

onMounted(async () => {
  await loadAllOrganizations();
});

async function loadAllOrganizations() {
  organizationsAreLoading.value = true;

  let organizations = await organizationService.getAllOrganizations();
  if (organizations && organizations.length > 0) {
    allOrganizations.value = organizations;
  }
  organizationsAreLoading.value = false;
}

</script>
